import React, { useEffect, useRef } from 'react';

import { action } from '../../../../../lib/actionHelpers';
import composerPhoneContactSelector from '../../../redux/composerPhoneContactSelector';
import confirmDialog from '../../../../../lib/confirmDialog';
import querySelector from '../../../../../selectors/lib/querySelector.js';
import setQuery from '../../../../../lib/setQuery.js';
import sortByProp from '../../../../../lib/sortByProp.js';
import { templateParser } from '../../../../../lib/messagesUtilities';
import { useSelector } from 'react-redux';
import FloatingSelect from '../../../../../components/FloatingSelect.js';
import selectors from '../../../../../selectors/selectors.js';

const TextComposerTemplateSelect = () => {
  const pipelineLeads = useSelector(selectors.activeLeadPipelineLeads);
  const templates = useSelector(selectors.serviceProviderTextTemplates).sort(sortByProp('template_name'));
  const templateId = useSelector(selectors.template);
  const composerPhoneMessage = useSelector((state) => state.leadModal.composerPhone.message);
  const platformRegistrationId = useSelector((state) => state.leadModal.composerPhone.platformRegistrationId);
  const platformMessage = useSelector(selectors.chatMessages).find((n) => platformRegistrationId && n.platform_registration_id === platformRegistrationId);
  const composerPhoneContact = useSelector(composerPhoneContactSelector);
  const pipelineLeadsRef = useRef([])

  useEffect(()=>{
    pipelineLeadsRef.current = pipelineLeads
  },[pipelineLeads])

  const templateOptions = templates.map((n) => ({ id: n.id, label: n.template_name }));

  useEffect(() => {
    const template = templates.find((item) => item.id === templateId);
    if (templateId && template) {
      setTimeout(() => {
        handleTemplateSelect(template, true);
      }, 0);
    }
  }, [templateId]);

  const handleTemplateSelect = async (template, autoConfirm = false) => {
    let message = templateParser(template.body, composerPhoneContact, pipelineLeadsRef.current || pipelineLeads, platformMessage);
    const confirm =
      autoConfirm || !composerPhoneMessage
        ? true
        : await confirmDialog({
            message: `Clicking Confirm will delete your current text message. Continue?`,
            confirm: 'Confirm',
            cancel: 'Cancel',
          });
    if (confirm) {
      if (templateId !== template.id) {
        setQuery({ template: template.id });
      }
      return action('leadModalPatchComposerPhone', {
        message: message,
      });
    }
  };

  const handleUseTemplateSelect = (option) => {
    const template = templates.find((n) => n.id === option.id);
    if (!option.id || !template) {
      return;
    }
    handleTemplateSelect(template);
  };

  return (
    <div>
      <div className={'use-template'}>Template</div>
      <FloatingSelect triggers={['.use-template']} options={templateOptions} onChange={handleUseTemplateSelect} />
    </div>
  );
};

export default TextComposerTemplateSelect;
